/* eslint-disable no-console */
/**
 * ai助手内容tab头部
 */
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import "./index.less";
import { connect } from "dva";
import { ChatMessage, EmployeeAttribute, Session, SessionProps } from "@/types/chat";
import ChatState, { AITabState, ICustomAppData } from "@/types/chat/State";

import CHAT_NOTICE from "@/contant/chat";
import IconFont from "@/components/icon";
import AINoticeTabList from "../AINoticeTabList";
import TabControllerModal from "./ControllerModal";
import ImService from "@/server/ImService";
import { Alert, Tabs, Tooltip } from "antd";
import { crossAppSwitch } from "@/utils/tools";
import { useHandleAITabClick } from "@/components/chat/Session/common";
import { generateSessionId, parseUidFromString } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { convertEmployeeToString } from "@jd/focus-desktop-comps/lib/es/UserCard/common";
import { filterNoticeSession } from "@/utils/chat/index";

const AI_NOTICE_TIP = "AI_NOTICE_TIP";
interface IProps {
  updateFilterTabList: Function;
  updateSelectedAITab: Function;
  filterTabList: any[];
  selectedSession: SessionProps;
  selectedAITab: AITabState;
  currentEmployee: any;
  launchAINoticeTabSession: Function;
  customAppList: Session[];
}

function AINoticeTabHeader(props: IProps) {
  const {
    filterTabList,
    updateFilterTabList,
    selectedSession,
    selectedAITab,
    updateSelectedAITab,
    currentEmployee,
    launchAINoticeTabSession,
    customAppList
  } = props;

  const [tabList, setTabList] = useState<AITabState[]>([]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [showTip, setShowTip] = useState<boolean>(false);

  const formatTabList = useCallback(
    (list: any[]) => {
      let tabList = filterNoticeSession(list, customAppList);
      if (tabList.findIndex((item: any) => item.pin === CHAT_NOTICE.ALL_PIN) === -1) {
        tabList.unshift({
          pin: "all-notice",
          name: "全部"
        });
      }
      return tabList;
    },
    [customAppList]
  );

  useEffect(() => {
    const array: any[] = [...formatTabList(filterTabList)];
    setTabList(array);
    return () => {
      // 修复重置状态
      updateSelectedAITab({
        selectedAITab: {
          pin: "all-notice",
          name: "全部"
        }
      });
    };
  }, [filterTabList, formatTabList, updateSelectedAITab]);

  const handleOk = (selectedTabList: any[]) => {
    handleCancel();
    const tabList = [...formatTabList(selectedTabList)];
    const selectedTabPin = selectedAITab.pin;
    if (!tabList.find((item) => item.pin === selectedTabPin)) {
      selectedAITab.pin = CHAT_NOTICE.ALL_PIN;
    }
    updateSelectedAITab({ selectedAITab });
    setTabList(tabList);
    updateSelectedTabList(selectedTabList);
  };

  const updateSelectedTabList = (selectedTabList: any[]) => {
    updateFilterTabList({ filterTabList: selectedTabList });
    ImService.getInstance().updateSession(selectedSession.sessionId, {
      ext: JSON.stringify({ filterTabList: selectedTabList })
    });
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleTabClick = (key: string) => {
    const session = tabList.find((item) => item.pin === key);
    if (session && selectedAITab.pin !== session.pin) {
      const { sessionId, pin } = session;
      launchAINoticeTabSession({ pin, sessionId });
    }
  };

  const getShowTip = useCallback(async () => {
    const hasTip = await ImService.getInstance()?.getAppModuleVersion(AI_NOTICE_TIP);
    return !hasTip;
  }, []);

  const handleTipClose = useCallback(async () => {
    const date = new Date().getTime();
    ImService.getInstance()?.setAppVersion(JSON.stringify({ date, version: 1 }), "AI_NOTICE_TIP");
  }, []);

  useEffect(() => {
    getShowTip().then((res: boolean) => {
      setShowTip(res);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="notice-tab-header">
      <div className="tab-list-content">
        <Tabs activeKey={selectedAITab.pin} onTabClick={handleTabClick}>
          {tabList.map((item) => (
            <Tabs.TabPane tab={item.name} key={item.pin} />
          ))}
        </Tabs>
      </div>
      <div className="controller-btn" onClick={() => setModalVisible(true)}>
        <Tooltip title="通知管理">
          <IconFont type="iconic_pc_im_tongzhishezhi" />
        </Tooltip>
      </div>
      {modalVisible && (
        <TabControllerModal
          visible={modalVisible}
          handleOk={handleOk}
          handleCancel={handleCancel}
          selectedTabList={[...filterTabList]}
          customAppList={customAppList}
        />
      )}
      {showTip && (
        <Alert
          className="notice-alert"
          message="点击“通知管理”，可以对单个应用的通知设置“消息免打扰”"
          type="warning"
          closable
          onClose={handleTipClose}
        />
      )}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const {
    filterTabList,
    selectedSession,
    selectedAITab,
    currentEmployee,
    customAppList
  } = chat as ChatState;

  return {
    filterTabList,
    selectedSession,
    selectedAITab,
    currentEmployee,
    customAppList
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    async updateFilterTabList(data: { selectedSession: SessionProps }) {
      await dispatch({ type: "chat/updateFilterTabList", payload: data });
    },
    async updateSelectedAITab(data: { selectedAITab: AITabState }) {
      await dispatch({ type: "chat/updateSelectedAITab", payload: data });
    },
    launchAINoticeTabSession(data: { sid: string }) {
      dispatch({ type: "chat/launchAINoticeTabSession", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AINoticeTabHeader);
